<template>
  <div>
    <div v-if="latestQuote">
      <p class="title">体積計算</p>
      <table class='table is-fullwidth is-hoverable'>
        <tr>
          <th width="150px">ファイル名</th>
          <td class="has-text-right">{{ latestQuote.fileName }}</td>
        </tr>
        <tr>
          <th>サイズ</th>
          <td class="has-text-right">W{{ latestQuote.width }}mm  H{{ latestQuote.height }}mm D{{ latestQuote.depth }}mm</td>
        </tr>
        <tr>
          <th>3Dプリント体積</th>
          <td class="has-text-right">{{ latestQuote.volume }}cm<sup>3</sup></td>
        </tr>
        
      </table>
      
    </div>
    <section class="section" v-else>
        <div class="content has-text-grey has-text-centered">
            <p>
                 <font-awesome-icon icon="hand-point-left" size='6x' />
            </p>
            <p>3Dモデルを選択してください</p>
        </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data(){
    return {
      selectedMaterial: null,
      minVolume: 3,
      priceList: {
        sla: 80,
        nylon: 100,
        transparent: 200
      },
      areaList: {
        sla: {
          width: 1400,
          height: 700,
          depth: 500,
        },
        nylon: {
          width: 356,
          height: 356,
          depth: 400,
        },
        transparent: {
          width: 1400,
          height: 700,
          depth: 500,
        },
      },
    }
  },
  computed: {
    isOverflow() {
      if (this.selectedMaterial === null) return false

      const area = this.areaList[this.selectedMaterial]
      return (
        this.latestQuote.width > area.width ||
        this.latestQuote.height > area.height ||
        this.latestQuote.depth > area.depth
      )
    },
    currentPrice() {
      const volume = this.latestQuote.volume > this.minVolume ? this.latestQuote.volume : this.minVolume
      return Math.ceil(volume * this.priceList[this.selectedMaterial])
    },
    currentPriceWithComma() {
      return ("" + this.currentPrice).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    },
    ...mapGetters(['latestQuote', 'allQuotes'])
  },
  methods: {
    updateQuote() {
      const quote = {
        id: this.latestQuote.id,
        material: this.selectedMaterial,
        price: this.currentPrice
      }
      this.$store.commit('updateQuote', quote)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>